import React from "react";
import styles from "./ProductContent.module.css";
import { Container, Row, Col } from "react-bootstrap";
import Slider from "react-slick";
import PricingCard from "../PricingCard/PricingCard";
import { SampleCard } from "../SampleCard";
import { useState } from "react";

const ProductContent = ({ data }) => {
  const [selectedPage, setSelectedPage] = useState(0);
  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },

      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <Container>
      <div className="d-flex align-items-center pt-5">
        {data.map((dt, i) => (
          <button
            key={i}
            className={`btn  ${styles.btn_order} ${
              selectedPage === i ? styles.active : ""
            } me-3`}
            onClick={() => setSelectedPage(i)}
          >
            {dt.title}
          </button>
        ))}
      </div>
      {data
        .filter((d, i) => i === selectedPage)
        .map((selectedData, j) => (
          <div key={j}>
            <Row>
              <Col className=" pt-0">
                <div className={"top_line mt-5"}></div>
                <span className={styles.title}>{selectedData.title}</span>
                <span className={styles.description}>
                  {selectedData.description}
                </span>
              </Col>
            </Row>
            <hr />
            <div className="" id="capabilities">
              <div className={styles.row}>
                <span className={styles.heading}>Features</span>

                <span className={styles.heading}>Capability</span>
              </div>
              {selectedData.features ? (
                selectedData.features.map((feature, index) => (
                  <div key={index} className={styles.row}>
                    <span className={styles.data_heading}>{feature.name}</span>

                    <span className={styles.data}>
                      {typeof feature.value === "string" ||
                      React.isValidElement(feature.value) ? (
                        feature.value
                      ) : typeof feature.value === "object" ? (
                        <>
                          <ul>
                            {feature.value.map((f, i) => (
                              <li key={i}>{f}</li>
                            ))}
                          </ul>
                        </>
                      ) : (
                        <></>
                      )}
                    </span>
                  </div>
                ))
              ) : (
                <></>
              )}
              {selectedData.pricing ? (
                <div className="">
                  <div className={"top_line mt-5"}></div>
                  <span className={styles.title}>Pricing</span>
                  <Slider {...settings}>
                    {selectedData.pricing.map((price, i) => (
                      <div key={i} className="p-3">
                        <PricingCard
                          name={price.name}
                          image={price.image}
                          price={price.price}
                          unit={price.unit}
                          data={price.data}
                          text={price.buildTime}
                        />
                      </div>
                    ))}
                  </Slider>
                </div>
              ) : (
                <></>
              )}
              {selectedData.products ? (
                <div className="pb-5">
                  <div className={"top_line mt-5"}></div>
                  <span className={styles.title}>Sample Pictures</span>
                  <Slider {...settings}>
                    {selectedData.products.map((prod, i) => (
                      <div key={i} className="p-3">
                        <SampleCard
                          name={prod.name}
                          image={prod.image}
                          subheading={prod.subheading}
                        />
                      </div>
                    ))}
                  </Slider>
                </div>
              ) : (
                <></>
              )}
            </div>
          </div>
        ))}
    </Container>
  );
};

export default ProductContent;
